module.exports = __webpack_public_path__ + "src/assets/img/SND2.a3858318.jpg";